import { hoursOptions } from 'util/constants';

export const formatApiHours = (apiHours, stateHours) => {
  const data = { ...stateHours };
  apiHours.forEach((el) => {
    data[el.dow.value] = {
      timeStart: {
        valueFormatted: el.time.start,
        value: hoursOptions.find(
          (option) => option.valueFormatted === el.time.start
        ).value,
      },
      timeEnd: {
        valueFormatted: el.time.end,
        value: hoursOptions.find(
          (option) => option.valueFormatted === el.time.end
        ).value,
      },
      dowId: el.dow.id,
    };
  });
  return data;
};
